import { useRoute } from "vue-router";
import { authenticationService } from "~/core/services";

export function useMeetingId() {
  const route = useRoute()

  return computed<string | null>(() => {
    const meetingIdFromParams = route.params.meetingId
    const meetingIdFromQuery = route.query.meetingId

    if (Array.isArray(meetingIdFromParams) && meetingIdFromParams.length > 0) {
      return meetingIdFromParams[0] ?? null
    }

    if (Array.isArray(meetingIdFromQuery) && meetingIdFromQuery.length > 0) {
      return meetingIdFromQuery[0] ?? null
    }

    if (typeof meetingIdFromParams === 'string' && meetingIdFromParams.length) return meetingIdFromParams

    if (typeof meetingIdFromQuery === 'string' && meetingIdFromQuery.length) return meetingIdFromQuery

    return null
  })
}

export const useStagiaireId = () => {
  const route = useRoute();

  const stagiaireId = ref<string | null>(null);

  const stagiaireIdParam = route.params.participantId;

  if (Array.isArray(stagiaireIdParam)) {
    // FIX ME : what's happen ?
    throw Error("Bad route");
  }

  stagiaireId.value = stagiaireIdParam ?? null;

  watch(
    () => !route.params.stagiaireId && route.fullPath,
    () => {

      if (!stagiaireIdParam) {
        if (route.query.participantId && !Array.isArray(route.query.participantId))
           stagiaireId.value = route.query.participantId;
        else
          stagiaireId.value = null;
      }
    },
    { deep: true, immediate: true },
  );

  return stagiaireId;
};

export const useTeamId = () => {
  const route = useRoute();
  const teamId = route.params.teamId;

  if (Array.isArray(teamId)) {
    // FIX ME : what's happen ?
    throw Error("Bad route");
  }

  return teamId;
};

export const useDailyTaskTeamId = () => {
  const route = useRoute();
  const dailyTaskTeamId = route.params.dailyTaskTeamId;

  if (Array.isArray(dailyTaskTeamId)) {
    // FIX ME : what's happen ?
    throw Error("Bad route");
  }

  return dailyTaskTeamId;
};

export const useResetPassIds = () => {
  const route = useRoute();
  const token = route.query.token;
  const uid = route.query.uid;

  if (token && uid) {
    if (Array.isArray(token) || Array.isArray(uid)) {
      // FIX ME : what's happen ?
      throw Error("Bad route");
    }
    return { token: token, uid: uid };
  } else {
    return { token: "", uid: "" };
  }
};
export const useQRCode = async () => {
  const route = useRoute();
  const qrcode_token = route.query.qrcode_token;
  const meeting_id = route.query.meeting_id;

  if (qrcode_token && meeting_id) {
    if (Array.isArray(qrcode_token) || Array.isArray(meeting_id)) {
      // FIX ME : what's happen ?
      throw Error("Bad route");
    }

    authenticationService.scanCode({
      qrCodeToken: qrcode_token,
      meetingId: meeting_id,
    });

    const destination = route.query.next as string ?? RouteUtils.getMeetingHome(meeting_id)
    await navigateTo(destination);
  }
};

export const useFormId = () => {
  const route = useRoute();
  const formId = route.params.formId;

  if (Array.isArray(formId)) {
    // FIX ME : what's happen ?
    throw Error("Bad route");
  }

  return formId;
};

export const useNoteId = () => {
  const route = useRoute();
  const noteId = route.params.noteId;

  if (Array.isArray(noteId)) {
    // FIX ME : what's happen ?
    throw Error("Bad route");
  }

  return noteId;
};

